import { SCOPE_NAME } from '.';
export var getLoadingRedux = function (state) {
    return state[SCOPE_NAME].loading;
};
export var getPageShowRedux = function (state) {
    return state[SCOPE_NAME].pageType;
};
export var getResetKeyRedux = function (state) {
    return state[SCOPE_NAME].resetKey;
};
export var getAnnouncementsRedux = function (state) {
    return state[SCOPE_NAME].announcements;
};
